import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Currency, CurrencyService } from 'taxtank-core';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AbstractControlComponent } from '@shared/component/form-controls/abstract-control/abstract-control.component';
import { MaterialModule } from '@shared/material/material.module';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-currency-select',
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule
  ],
  templateUrl: './currency-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './currency-select.component.scss',
})
export class CurrencySelectComponent extends AbstractControlComponent<string> implements OnInit {
  @Input() placeholder = 'Select Currency';
  @Input() label = 'Select Currency';
  @Input() multiple = false;
  filterCtrl = new FormControl<string>('');
  options: Currency[];
  filteredOptions: Currency[];

  public ngControl = inject(NgControl);
  protected dialog = inject(MatDialog);
  private currencyService = inject(CurrencyService);

  ngOnInit(): void {
    super.ngOnInit();

    this.options = [{ code: 'AUD', name: 'Australian Dollar' } as Currency, ...this.currencyService.getCache().toArray()];
    this.filteredOptions = this.options;
    this.value = this.value ?? this.options[0].code;

    this.filterCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.filteredOptions = this.options.filter(currency =>
          currency.code.toLowerCase().includes(value.toLowerCase()) ||
          currency.name.toLowerCase().includes(value.toLowerCase()));
      });
  }
}
